import { Comment } from './Comment';
import { Folder } from './Folder';
import { PipelineCollaborator } from './PipelineCollaborator';
import { PipelineColumn } from './PipelineColumn';
import { Team } from './Team';
import { User } from './User';
import { Workspace } from './Workspace';

export enum PipelineType {
    TEAM = 'Team',
    SHARED = 'Shared',
    PERSONAL = 'Personal',
    CONNECTED = 'Connected',
}

export enum PipelineVisibilityType {
    PRIVATE = 'Private',
    LINK = 'Link',
    WORKSPACE = 'Workspace',
}

export enum PipelineView {
    KANBAN = 'Kanban',
    LIST = 'List',
}

export interface Pipeline {
    id: string;
    user: User;
    workspace: Workspace;
    columns: PipelineColumn[];
    name: string;
    type: PipelineType | undefined;
    view: PipelineView | undefined;
    visibility: PipelineVisibilityType | undefined;
    isFavorite: boolean;
    isLocked: boolean;
    isArchived: boolean;
    folder: Folder;
    team: Team;
    comments: Comment[];
    collaborators: PipelineCollaborator[];
    createdAt: Date;
    updatedAt: Date;
    deletedAt?: Date;
}
